import getBucketsFromChildren from './getBucketsFromChildren';
import { FetchMultipleExperimentsWithIdentifier, Cookies } from '../services';
import { Experiment } from '../SharedTypes';

const initializeExperimentState = (defaultBucket, buckets, previousValues) => ({
  ...previousValues,
  defaultBucket:
    defaultBucket || previousValues?.defaultBucket || 'control',
  buckets: [
    ...Array.from(new Set(
      (previousValues?.buckets || []).concat([...buckets, 'control'])
    ))
  ]
});

const assignBucket = (assignedBucket, state, hasErrored = false) => ({
  ...state,
  assignedBucket,
  isLoading: false,
  hasErrored
});

const RegisterMultipleExperiments = async (props, updateExperiment) => {
  const {
    experimentsToRegister,
    experiments,
    serverCookies,
    ignoreExistingExperiments = false
  } = props;
  const experimentBucketsToFetch: string[] = [];
  const assignedExperimentBuckets: Experiment[] = [];

  experimentsToRegister.forEach(({ experimentName: name, defaultBucket }) => {
    const existingExperiment = experiments[name];
    experiments[name] = initializeExperimentState(defaultBucket, [], experiments[name]);
    updateExperiment(name, experiments);

    const preloadedBucket = Cookies.get(name) || serverCookies[name];

    if (preloadedBucket) {
      experiments[name] = assignBucket(preloadedBucket, experiments[name]);
      assignedExperimentBuckets.push(updateExperiment(name, experiments));
    }

    const shouldFetchBucket = !preloadedBucket && (ignoreExistingExperiments || !existingExperiment);
    if (shouldFetchBucket) {
      experimentBucketsToFetch.push(name);
    }
  });

  if (experimentBucketsToFetch.length < 1) {
    return assignedExperimentBuckets;
  }

  const fetchedExperimentBuckets = await FetchMultipleExperimentsWithIdentifier(
    { ...props, experiments: experimentBucketsToFetch }
  );
  const fetchedExperimentsByName = fetchedExperimentBuckets.reduce(
    (acc, { experimentName, assignedBucket }) => {
      acc[experimentName] = assignedBucket;
      return acc;
    },
    {}
  );
  experimentBucketsToFetch.forEach(name => {
    const { defaultBucket = 'control' } = experiments[name];
    const assignedBucket = fetchedExperimentsByName[name];
    const hasErrored = !assignedBucket;
    experiments[name] = assignBucket(assignedBucket || defaultBucket, experiments[name], hasErrored);
    assignedExperimentBuckets.push(updateExperiment(name, experiments));
  });

  return assignedExperimentBuckets;
};

export default RegisterMultipleExperiments;
